(function () {

    'use strict';

    angular.module('Services').service('AccountingHistoricalBillingTableService', AccountingHistoricalBillingTableService);

    AccountingHistoricalBillingTableService.$inject = [
        'AccountingService',
        'TableLiteFactory',
        'toastr',
        '$filter'
    ];

    function AccountingHistoricalBillingTableService(
        AccountingService,
        TableLiteFactory,
        toastr,
        $filter
    ){
        return function () {
            const tableData = {
                tableName: 'AccountingHistoricalBillingTable',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    colMinWidth: '120px'
                },
                headers: [
                    {
                        label: 'Date of Invoiced to Customer',
                        viewName: 'issuedDate',
                        filterName: 'issueDate',
                        sortName: 'issuedDate',
                        filter: {
                            type: 'datePicker',
                            class: 'filter-date',
                            useArray: true,
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.sortName);
                        }
                    },
                    {
                        label: 'Customer Name',
                        viewName: 'customerName',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            },
                            model: '' //optional
                            //text and inputDropdown uses `model` attribute for ng-model
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Invoicing Sent to Company Accounting System',
                        viewName: 'sentToCustomer'
                    },
                    {
                        label: 'Emailed to Customer',
                        viewName: 'emailedToCustomer',
                        width: '160px'
                    },
                    {
                        label: 'Payment Status',
                        viewName: 'paymentStatus',
                        class: 'text-uppercase',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Status',
                        viewName: 'status',
                        class: 'text-uppercase',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },{
                        "label": "ACTION",
                        "viewName": "actions",
                    }
                ],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.Invoices.historicalBillings,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    console.log(err);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    pending: false,
                    sort: 'id,desc'
                }
            });
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data)
                    return null;
                angular.forEach(data.content, function (row) {
                    row.issuedDate = $filter('bbaDate')(row.issuedDate);
                    row.customerName = row.customer.name || 'N/A';
                    row.sentToCustomer = row.sentToThirdPartyAccountingDate ? 'Yes' : 'No';
                    row.emailedToCustomer = row.emailedToCustomerDate ? $filter('bbaDate')(row.emailedToCustomerDate) : 'No';
                    row.actions = {
                        type: 'button',
                        buttons: [{
                            text: 'Download PDF',
                            class: 'btn btn-primary',
                            action: function () {
                                downloadFile(row, 'application/pdf')
                            }
                        },{
                            text: 'Download CSV',
                            class: 'btn btn-primary',
                            action: function () {
                                downloadFile(row, 'text/csv')
                            }
                        }]
                    };
                    if(row.status === 'disputed') {
                        row.class = 'bg-error'
                    } else if(row.status === 'discrepancy') {
                        row.class = 'bg-warning'
                    }
                    row.href = '/accounting/historical-billing/' + row.id;
                    tableData.data.push(row);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;

            function downloadFile(data, fileType) {
                const payload = {
                    id: data.id,
                    fileType: fileType
                };
                AccountingService.Invoices.downloadFile(function(result) {
                    // download(result, 'customer-billing.' + type.split('/')[1], type);
                }, function(error) {
                    toastr.error(error.message || 'Try again', 'Unable to download file');
                }, payload);
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/AccountingHistoricalInvoicesTableService.js